import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#BEC7B4"
        }
    },
    background: {
        default: "#FFFEF2"
    }
})

export default theme;